module.exports = __webpack_public_path__ + "static/media/slide1.f18b7b21.png";